import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DashboardQueryComponent } from "./dashboard-query/dashboard-query.component";

const routes: Routes = [{ path: "", component: DashboardQueryComponent }];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: true, relativeLinkResolution: "legacy" })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
